import { render, staticRenderFns } from "./RicercaLavori.vue?vue&type=template&id=6633c01e&scoped=true&"
import script from "./RicercaLavori.vue?vue&type=script&lang=js&"
export * from "./RicercaLavori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6633c01e",
  null
  
)

export default component.exports